export default "<img ng-src=\"{{$ctrl.srcPath}}\" class=\"{{$ctrl.userPersona}}\" alt=\"App Logo\" />\n"